module.exports = __webpack_public_path__ + "static/media/04_tn.74a4e866.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/04_tn.jpg
// module id = 493
// module chunks = 0